import React, { useState } from 'react';
import ajaxVendor from '../util/remote/ajaxVendor';
import ajaxAdmin from '../util/remote/ajaxAdmin';

const AdminContext = React.createContext();

export const AdminConsumer = AdminContext.Consumer;

export const AdminProvider = (props)=> {
   const [vendorList, setVendorList] = useState(false);
   const [vendorListByPage, setVendorListByPage] = useState([])
   const [schoolAdminListByPage, setSchoolAdminListByPage] = useState([])

   const [page, setPage] = useState(1);
   const [adminPage, setAdminPage] = useState(1);

   const [meta, setMeta] = useState([]);
   const [adminMeta, setAdminMeta] = useState([]);

   const [loading, setLoading] = useState(false);
   const [loading2, setLoading2] = useState(false);
   const [loading3, setLoading3] = useState(false);
   const [loading4, setLoading4] = useState(false);
   const [loading5, setLoading5] = useState(false);

   const [query, setQuery] = useState("");
   const [adminQuery, setAdminQuery] = useState("");

   const [first, setFirst] = useState("");
  const [school, setSchool] = useState("");
  const [adminFirst, setAdminFirst] = useState("");
  const [adminSchool, setAdminSchool] = useState("");

   const [data, setData]= useState({page:"1"})

   

   const getVendorList =async()=>{
      setLoading(true);
      const server_response = await ajaxVendor.fetchVendorList();
      setLoading(false);

      if(server_response.status==="OK"){
         //store results
         setVendorList(server_response.details);
      }else{
         //communicate error
         setVendorList([]);
      }
   }

   const getVendorListByPage = async (currentPage) => {
       setVendorListByPage([]);
       setLoading2(true);
       const server_response = await ajaxVendor.fetchVendorListByPage(currentPage);
       setLoading2(false);
       if (server_response.status === "OK") {
         setFirst(server_response.details.meta.offset);
         setMeta(server_response.details.meta.totalPages)
         setVendorListByPage(server_response.details.list || []);
       } else {
         setVendorListByPage([]);
       }
   };

   const searchVendors = async (e) => {
       if (e) {
           e.preventDefault();
       }
       setLoading3(true);
       const server_response = await ajaxVendor.searchAllVendors(query, page, school);
       setLoading3(false);
       if (server_response.status === "OK") {
         setFirst(server_response.details.meta.offset);
         setMeta(server_response.details.meta.totalPages);
         setVendorListByPage(server_response.details.list || []);
         
       } else {
         setVendorListByPage([]);
       }
       
     };


     const getSchoolAdminListByPage = async (currentPage) => {
       setSchoolAdminListByPage([]);
       setLoading4(true);
       const server_response = await ajaxAdmin.fetchSchoolAdminListByPage(currentPage);
       setLoading4(false);
       if (server_response.status === "OK") {
         setAdminFirst(server_response.details.meta.offset);
         setAdminMeta(server_response.details.meta.totalPages)
         setSchoolAdminListByPage(server_response.details.list || []);
       } else {
         setSchoolAdminListByPage([]);
       }
   };

   const searchSchoolAdmins = async (e) => {
       if (e) {
           e.preventDefault();
       }
       setLoading5(true);
       const server_response = await ajaxAdmin.searchAllSchoolAdmins(adminQuery, adminPage, adminSchool);
       setLoading5(false);
       if (server_response.status === "OK") {
         setAdminFirst(server_response.details.meta.offset);
         setAdminMeta(server_response.details.meta.totalPages);
         setSchoolAdminListByPage(server_response.details.list || []);
         
       } else {
         setSchoolAdminListByPage([]);
       }
       
     };
    
    return (
           <AdminContext.Provider value={
               {
                    vendorList,
                    vendorListByPage,
                    schoolAdminListByPage,
                    adminMeta,
                    adminFirst,
                    adminPage,
                    adminQuery,
                    adminSchool,
                    meta,
                    query,
                    page,
                    first,
                    school,
                    loading,
                    loading2,
                    loading3,
                    loading4,
                    loading5,
                    data,
                  setData,
                  setAdminFirst,
                  setAdminMeta,
                  setAdminPage,
                  setAdminQuery,
                  setAdminSchool,
                  setMeta,
                  setQuery,
                  setPage,
                  setSchool,
                  setFirst,
                  getVendorList,
                  getVendorListByPage,
                  getSchoolAdminListByPage,
                  searchSchoolAdmins,
                  searchVendors
               }
               }>
               {props.children}
           </AdminContext.Provider>
        );
    
}

export default AdminContext;